import { stripNumericPathPrefix } from '../tutorialSlug/utils/stripNumericPathPrefix'

function resolvePath(baseDir: string, relativePath: string): string {
  const baseParts = baseDir ? baseDir.split('/').filter(Boolean) : []
  const relativeParts = relativePath.split('/').filter(Boolean)
  const stack = [...baseParts]

  for (const part of relativeParts) {
    if (part === '..') {
      stack.pop()
    } else if (part !== '.') {
      stack.push(part)
    }
  }

  return stack.join('/')
}

function toPublicPath(baseRoute: string, cleaned: string): string {
  if (baseRoute === 'documentation' || baseRoute === '') {
    return `/${cleaned}`
  }

  return `/${baseRoute}/${cleaned}`
}

export function transformMarkdownLinks(content: string, currentPath: string, baseRoute: string): string {
  if (!currentPath || !baseRoute) return content

  const baseDir =
    currentPath.endsWith('.md') || currentPath.endsWith('.mdx')
      ? currentPath.split('/').slice(0, -1).join('/')
      : currentPath

  return content.replace(/\[([^\]]+)\]\(((?!https?:\/\/|\/)[^)]+\.mdx?)\)/g, (_match, text: string, href: string) => {
    const resolved = resolvePath(baseDir, href)
    const withoutExt = resolved.replace(/\.mdx?$/, '')
    const cleaned = stripNumericPathPrefix(withoutExt).replace(/^docs\//, '')
    return `[${text}](${toPublicPath(baseRoute, cleaned)})`
  })
}
